// removed by extract-text-webpack-plugin
module.exports = {"inputName":"inputName__lTV_T","requestButtonContainer":"requestButtonContainer__2tEwy"};


//////////////////
// WEBPACK FOOTER
// ./routes/account/components/otpBox/style.css
// module id = NSQi
// module chunks = 446